var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { class: _vm.bemBlock }, [
    _c("p", { class: _vm.bemElement("title", { disabled: _vm.isDisabled }) }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$msg("button.stockalert", "product")) + "\n  "
      )
    ]),
    _vm._v(" "),
    !_vm.isDisabled
      ? _c("div", [
          _vm.stockAlertSize &&
          _vm.stockAlertSize.id !== "" &&
          _vm.stockAlertSize.id !== "UN"
            ? _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hiddenForm,
                      expression: "!hiddenForm"
                    }
                  ],
                  class: _vm.bemElement("explanation")
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$msg("stockalert.explanation", "product", [
                          _vm.stockAlertSize.displayValue
                        ])
                      ) +
                      "\n    "
                  )
                ]
              )
            : _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hiddenForm,
                      expression: "!hiddenForm"
                    }
                  ],
                  class: _vm.bemElement("explanation")
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$msg("stockalert.explanation.singleSize", "product")
                      ) +
                      "\n    "
                  )
                ]
              ),
          _vm._v(" "),
          _c(
            "form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.hiddenForm,
                  expression: "!hiddenForm"
                }
              ],
              ref: "notifyForm",
              class: _vm.bemElement("form"),
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                }
              }
            },
            [
              _c("BaseFieldText", {
                ref: "email",
                class: _vm.bemElement("mail"),
                attrs: {
                  id: "stock-alert-popup-mail",
                  bem: "stock-alert-popup-mail",
                  name: "stock-alert-popup-mail",
                  "input-type": "email",
                  type: "primary",
                  label: _vm.$msg("label.input.email", "forms"),
                  pattern: _vm.emailRegex,
                  "error-messages": {
                    patternMismatch: _vm.$msg(
                      "error.message.parse.email.profile.form",
                      "forms"
                    )
                  }
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.stockAlertVisible || _vm.isBreakpointDesktop,
                      expression: "stockAlertVisible || isBreakpointDesktop"
                    }
                  ],
                  class: [
                    _vm.bemElement("form-submit"),
                    _vm.isBreakpointMobile
                      ? "btn--cta"
                      : "btn--primary interaction--enable-disable-form-v1",
                    "btn",
                    { disabled: _vm.disableSubmit }
                  ],
                  attrs: { type: "submit" }
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$msg("stockalert.submit", "product")) +
                        "\n        "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.message.visible,
                  expression: "message.visible"
                }
              ],
              ref: "message",
              class: _vm.bemElement("message", _vm.message.modifier)
            },
            [_vm._v("\n      " + _vm._s(_vm.message.text) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.message.visible &&
                    _vm.message.modifier === "success" &&
                    _vm.isBreakpointMobile,
                  expression:
                    "\n        message.visible &&\n        message.modifier === 'success' &&\n        isBreakpointMobile\n      "
                }
              ],
              class: [_vm.bemElement("success-button"), "btn--cta", "btn"],
              attrs: { type: "button" }
            },
            [
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$msg("stockalert.success", "product")) +
                    "\n      "
                )
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }